export default __webpack_public_path__ + "static/media/desktop_landing.7aaa07c2.svg";